<script setup>
import NavBar from './components/NavBar.vue';
import FooterBar from './components/FooterBar.vue';

</script>






<template>
 
 <div id="app">
<main class="main-content">
    <NavBar/>
<RouterView /> 
</main>



<FooterBar/>
 </div>
</template>




<style>
html, body, #app {
height: 100%;
margin: 0;
padding: 0;
}
#app {
display: flex;
flex-direction: column;


}
.main-content {
    flex: 1;
}

</style>

